var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSync = function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m9.706 1.708-.312.311c3.665.207 6.588 3.236 6.605 6.947A1 1 0 1 1 14 9c0-2.598-2-4.716-4.539-4.954l.246.247a1 1 0 1 1-1.414 1.414l-1.999-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.413 1.415ZM2 7c0 2.598 2.001 4.716 4.539 4.953l-.246-.246a1 1 0 1 1 1.414-1.415l1.999 2.001a1 1 0 0 1 0 1.414l-1.999 2a1 1 0 0 1-1.414-1.415l.312-.312C2.932 13.773.005 10.731 0 7.01V7a1 1 0 0 1 2 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgSync;